import { VideoOtherProps } from "./types";
import { useUpdateModal } from "utilities/ModalProvider";
import DefaultVideo from "./DefaultVideo";
import Modal from "components/Modal";
import React from "react";
import VideoCta from "./VideoCta";
import VideoPreviewImage from "./VideoPreviewImage";

const InModalVideo = (props: VideoOtherProps) => {
  const { autoplay = true, previewImage, ...otherProps } = props;
  const { videoLocal, videoYoutube } = props;
  const id = videoLocal !== "" ? videoLocal : videoYoutube;
  const { openModal } = useUpdateModal();
  const playVideo = () => {
    openModal?.(id);
  };

  return (
    <>
      {previewImage ? (
        <VideoPreviewImage playVideo={playVideo} previewImage={previewImage} />
      ) : (
        <VideoCta playVideo={playVideo} />
      )}
      <Modal id={id} modalType="full-width">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-10 d-flex justify-content-center">
              <DefaultVideo autoplay {...otherProps} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InModalVideo;
